import { render, staticRenderFns } from "./DataFilters.vue?vue&type=template&id=3f00977a&scoped=true&"
import script from "./DataFilters.vue?vue&type=script&lang=ts&"
export * from "./DataFilters.vue?vue&type=script&lang=ts&"
import style0 from "./DataFilters.vue?vue&type=style&index=0&id=3f00977a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f00977a",
  null
  
)

export default component.exports